export const divFlexAlignMargin24_4 = {
  display: 'flex',
  alignItems: 'center',
  marginTop: 24,
  marginBottom: 4
};

export const divFlex1Align = {
  flex: 1,
  display: 'flex',
  alignItems: 'center'
};

export const spanFormControlLabelTime = (timeError) => ({
  color: timeError ? '#c44d4d' : undefined,
  fontWeight: timeError ? 600 : undefined
});

export const formTooltip = {
  fontSize: '0.85rem',
  maxWidth: '200px'
};

export const divMarginBottom4MaxWidth320 = {
  marginBottom: 4,
  maxWidth: 320
};

export const inputTimeInMinutes = (timeError) => ({
  width: '100%',
  background: timeError ? '#ffe6e6' : undefined,
  borderColor: timeError ? '#c44d4d' : '#C4C4C4',
  color: timeError ? '#c44d4d' : undefined,
  fontWeight: timeError ? 500 : undefined
});

export const divErrorTime = {
  display: 'flex',
  alignItems: 'center',
  marginTop: 2,
  marginBottom: 16,
  transition: 'opacity 0.3s',
  opacity: 1
};

export const spanErrorIcon = {
  display: 'inline-flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '1rem',
  height: '1rem',
  borderRadius: '50%',
  background: 'radial-gradient(circle, #ff6666, #cc0000)',
  color: 'white',
  fontWeight: 700,
  marginRight: '0.4rem',
  fontSize: '0.7rem',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
};

export const spanErrorText = {
  color: '#c44d4d',
  fontWeight: 700,
  fontSize: '0.75rem'
};

export const divFlexAlignMargin24_4_2 = {
  display: 'flex',
  alignItems: 'center',
  marginTop: 24,
  marginBottom: 4
};

export const divFlex1Align_2 = {
  flex: 1,
  display: 'flex',
  alignItems: 'center'
};

export const divMarginBottom16MaxWidth320 = {
  marginBottom: 16,
  maxWidth: 320
};

export const divFlexAlignMargin24_4_3 = {
  display: 'flex',
  alignItems: 'center',
  marginTop: 24,
  marginBottom: 4
};

export const divFlex1Align_3 = {
  flex: 1,
  display: 'flex',
  alignItems: 'center'
};

export const spanFormControlLabelExpediente = {
  marginRight: 4,
  whiteSpace: 'nowrap'
};

export const inputCheckbox = {
  marginLeft: 2,
  marginRight: 8,
  position: 'relative',
  top: '1px'
};

export const divFlexJustifyEnd = {
  display: 'flex',
  justifyContent: 'flex-end',
  flex: 1,
  position: 'relative',
  top: '1px'
};

export const buttonPrimary = (isSubmitDisabled) => ({
  opacity: isSubmitDisabled ? 0.4 : 1,
  pointerEvents: isSubmitDisabled ? 'none' : 'auto',
  transition: 'opacity 0.2s'
});
